import { motion } from "framer-motion";
import { PORTFOLIO } from "./data";

export const Portfolio = () => (
    <section id="portfolio" data-testid="portfolio-section" className="bg-[#FDFBF7] py-24">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Portfolio</p>
            <h2 className="mt-3 max-w-xl font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Real brides. Real dream looks.
            </h2>
            <div className="mt-14 columns-2 gap-4 md:columns-3 md:gap-6 [&>figure]:mb-4 md:[&>figure]:mb-6">
                {PORTFOLIO.map((img, i) => (
                    <motion.figure
                        key={img.url}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                        className="break-inside-avoid overflow-hidden rounded-sm border border-[#D4AF37]/20"
                    >
                        <img
                            src={img.url}
                            alt={img.alt}
                            loading="lazy"
                            data-testid={`portfolio-image-${i}`}
                            className="max-h-[80vh] w-full object-cover transition-transform duration-500 hover:scale-105"
                        />
                    </motion.figure>
                ))}
            </div>
        </div>
    </section>
);
